import React from "react"
import { AppContext } from "./AppContext";

class AppContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      entity: null,
      show_alert: false,
      alert_type: '',
      alert_message: '',
      show_info: false,
      submitting: false,
    };
  }

  render() {
    return (
      <AppContext.Provider value={{
        updateEntity: (entity) => { this.setState({ entity }) },
        getEntity: () => this.state.entity,
        modifyAlert: (type, message) => this.setState({ alert_type: type, alert_message: message }),
        showAlert: () => this.setState({ show_alert: true }),
        hideAlert: () => this.setState({ show_alert: false }),
        showInfo: () => this.setState({ show_info: true }),
        hideInfo: () => this.setState({ show_info: false }),
        setSubmitting: () => this.setState({ submitting: true }),
        setSubmitted: () => this.setState({ submitting: false }),
        alert: {
          show: this.state.show_alert,
          type: this.state.alert_type,
          message: this.state.alert_message,
        },
        info: {
          show: this.state.show_info,
        },
        isSubmitting: this.state.submitting,
      }}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppContextProvider;
